import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import MasterHoldMaintenanceCont from "presentation/view/container/MasterHold/MasterHoldContMain";

CommonEntrypoint(<MasterHoldMaintenanceCont/>)